import { useQuery } from 'react-query';
import { readApiErrorMessage } from '../../../shared/api/readApiErrorMessage';
import TranslationsApi from './TranslationsApi';
import { TranslationDto } from '../types';
import { translationQueryKey } from './queryKeys';

async function loadTranslation(key: string): Promise<TranslationDto> {
    try {
        return await TranslationsApi.get(key);
    } catch (error) {
        throw new Error(await readApiErrorMessage(error));
    }
}

export function useTranslationQuery(key: string | null) {
    return useQuery<TranslationDto, Error>([translationQueryKey, key], () => loadTranslation(key), {
        enabled: key !== null,
        refetchOnWindowFocus: false
    });
}
